import type { BrowserMatchReplaceRuleWithRelations } from '@terra/shared-schemas-orchestrator';
import type { MatchReplaceRule } from '../store/proxy-store';
import { mapLocalMatchReplaceRuleToBrowser } from './match-replace-rule.mapper';

export type MatchReplacePersistSnapshot = {
  applicationId: string;
  rules: BrowserMatchReplaceRuleWithRelations[];
  matchReplaceEnabled: boolean;
};

export function captureMatchReplacePersistSnapshot({
  applicationId,
  rules,
  matchReplaceEnabled,
}: {
  applicationId: string | undefined;
  rules: MatchReplaceRule[];
  matchReplaceEnabled: boolean;
}): MatchReplacePersistSnapshot | null {
  if (!applicationId) {
    return null;
  }

  return {
    applicationId,
    rules: rules.map(mapLocalMatchReplaceRuleToBrowser),
    matchReplaceEnabled,
  };
}

export function buildServerRulesSyncKey({
  applicationId,
  rules,
}: {
  applicationId: string;
  rules: MatchReplaceRule[];
}): string {
  return `${applicationId}:${rules.map((rule) => rule.id).join('|')}:${rules.length}`;
}
